<template>
  <div id="app">
    <template v-if="$route.meta.authRequired">
      <v-app id="inspire">
        <div class="app-container">
          <toolbar
            @toggleNavigationBar="drawer = !drawer"
            @screenload="setScreenLoad"
            @zeroCompleted="stepZero"
            @oneCompleted="stepOne"
            @cleanLoaderMsg="loaderPropMsg = ''"
            class="blue darken-4"
            id="toolbar-jintronic"
            ref="toolbarjintronic"
          />
          <navigation :toggle="drawer" id="drawer-jintronic"/>
          <v-main>
            <breadcrumbs id="bread-jintronic" />
            <router-view
              class="routerView"
              id="routerView"
              @activateToolAction="toolAction"
              :key="this.routerKey"
            ></router-view>
            <page-footer id="footer-jintronic" class="footer" />
          </v-main>
        </div>
      </v-app>
    </template>
    <template v-else-if="!$route.meta.allowAnonymous">
      <transition>
        <keep-alive> <router-view></router-view> </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: true,
      screenLoad: false,
      routerKey: 0,
      loaderPropMsg: ''
    };
  },
  methods: {
    getScreenLoad() {
      return this.screenLoad;
    },
    setScreenLoad() {
      this.screenLoad = !this.screenLoad;
      if(this.screenLoad) this.routerKey++
    },
    toolAction(){
      this.$refs.toolbarjintronic.handleFileImport()
    },
    stepOne(){
      this.loaderPropMsg = '1/2'
    },
    stepZero(){
      this.loaderPropMsg = '0/2'
    },
  },
};
</script>

<style>
#boatSailingMain{
  margin-top: 2em;
}
.container {
  width: 100%;
}
::-webkit-scrollbar {
  width: 10px;
}
.v-data-table {
  margin: 2em;
}
::-webkit-scrollbar-track {
  background-color: darkgrey;
}
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 20px #004283;
}
h1 {
  text-align: center;
}
.v-application--wrap {
  background-color: #f2f6fa;
}
.v-toolbar__content {
  height: 100%;
}
.v-main__wrap {
  text-align: center;
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue